import React from 'react';
import { useTranslation } from 'react-i18next';
import Reports from '../components/reports/Reports';

const ReportsPage = () => {
    const { t } = useTranslation();
    return <Reports />;
};

export default ReportsPage;
